import { useEffect, useState } from 'react'
import Popup, { PopupSize } from '../../components/popup/Popup'
import { AppInput } from '../../components/AppInput/AppInput'
import AppBtn, { AppBtnColor, AppBtnSize } from '../../components/btn/AppBtn'
import {
  AppNotification,
  NotificationType,
} from '../../components/notification/Notification'
import {
  useCreateMismatchTypeMutation,
  useGetMismatchTypeDetailQuery,
  useUpdateMismatchTypeMutation,
} from '../../core/api/TypeMismatchApi'
import { useTranslation } from 'react-i18next'

interface IAddMismatchTypePopupProps {
  id?: number | null
  closePopup: () => void
}

export const AddTypeMismatchPopup = ({
  closePopup,
  id,
}: IAddMismatchTypePopupProps) => {
  const { t } = useTranslation()
  const [title, setTitle] = useState('')
  const [error, setError] = useState('')

  const { data: currentMismatchType } = useGetMismatchTypeDetailQuery(
    { id: Number(id) },
    {
      skip: !id,
    },
  )
  const [createMismatchType, { isLoading: isLoadingCreate }] =
    useCreateMismatchTypeMutation()
  const [updateMismatchType, { isLoading: isLoadingUpdate }] =
    useUpdateMismatchTypeMutation()

  useEffect(() => {
    if (!!currentMismatchType) {
      setTitle(currentMismatchType.name)
    }
  }, [currentMismatchType])

  const onSaveHandler = () => {
    if (!title) {
      setError('Обязательное поле')
      return
    }
    if (!!id) {
      updateMismatchType({ id, data: { name: title.toLocaleLowerCase() } })
        .unwrap()
        .then((data) => {
          AppNotification({
            msg: t('Тип несоответствия успешно обновлен!'),
            type: NotificationType.success,
          })
          closePopup()
        })
    } else {
      createMismatchType({ name: title.toLocaleLowerCase() })
        .unwrap()
        .then((data) => {
          AppNotification({
            msg: t('Тип несоответствия успешно создан!'),
            type: NotificationType.success,
          })
          closePopup()
        })
    }
  }

  return (
    <Popup
      size={PopupSize.base}
      borderRadiusMin
      closePopup={closePopup}
      isLoading={isLoadingCreate || isLoadingUpdate}
    >
      <div className="category-popup">
        <h3>
          {t(`${!!id ? 'Редактирование' : 'Создание'} типа несоответствия`)}
        </h3>
        <AppInput
          value={title}
          onChange={(value) => {
            setError('')
            setTitle(value)
          }}
          label="Название"
          border
          fullWidth
          error={error ? error : undefined}
          // disabled={isDisabled}
        />

        <div className="buttons-block">
          <AppBtn
            title={'Отменить'}
            color={AppBtnColor.outlineViolet}
            iconClassName={'close'}
            sized={AppBtnSize.md}
            onClick={closePopup}
          />
          <AppBtn
            iconClassName={'save'}
            title={'Сохранить'}
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            onClick={onSaveHandler}
            // disabled={isDisabled}
          />
        </div>
      </div>
    </Popup>
  )
}
